/* Fransk katalog for locale-invoice-list-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'inv.title': 'Liste des factures',
  'inv.titleHelp': 'Aperçu des factures, devis, confirmations de commande et avoirs pour l\'exercice sélectionné.',
  'inv.searchPh': 'Rechercher par numéro de facture, client ou montant',
  'inv.searchHelp': 'Recherchez dans la liste par numéro de facture, nom du client, montant de la facture, montant HT, montant payé ou montant restant.',
  'inv.downloadHelp': 'Téléchargez la liste pour l\'onglet et le filtre sélectionnés.',
  'inv.addHelp': 'Créez une nouvelle facture.',
  'inv.add': 'Nouvelle facture',
  'inv.filterHelp': 'Filtrez la liste par statut, type de document, date, période, montant et archive.',
  'inv.tabsHelpTitle': 'Types de documents',
  'inv.tabsHelp': 'Basculez entre Facture, Brouillon, Devis/Confirmation de commande, Avoir et Rapport des ventes.',
  'inv.listHelpTitle': 'La liste des factures',
  'inv.listHelp': 'Chaque ligne est un document provenant du backend. Touchez une ligne pour voir les détails et les actions.',
  'inv.loading': 'Chargement des factures',
  'inv.loadingSub': 'Récupération des données depuis le backend.',
  'inv.noMatch': 'Aucun résultat ici',
  'inv.noMatchSub': 'Essayez un autre onglet ou réinitialisez le filtre.',
  'inv.backToVouchers': 'Retour aux transactions',
  'inv.type.invoice': 'Facture',
  'inv.type.quote': 'Devis',
  'inv.type.orderConfirmation': 'Confirmation de commande',
  'inv.type.creditNote': 'Avoir',
  'inv.type.unknown': 'Document',
  'inv.tab.salesReport': 'Rapport des ventes',
  'inv.importHistory.tab': 'Historique importé',
  'inv.importHistory.loading': 'Chargement de l\'historique des factures importé …',
  'inv.importHistory.error': 'Impossible de charger l\'historique des factures importé.',
  'inv.importHistory.readOnly': 'Il s\'agit d\'un historique en lecture seule provenant de l\'ancien système. Ces éléments n\'affectent ni la comptabilité ni la TVA et n\'ont aucune action de facture dans Plumme.',
  'inv.importHistory.documents': 'Documents',
  'inv.importHistory.year': 'Historique importé pour {year}',
  'inv.importHistory.netSales': 'Ventes HT',
  'inv.importHistory.customers': 'Clients',
  'inv.importHistory.creditNotes': 'Avoirs',
  'inv.importHistory.netIncluded': 'Déduit des ventes HT',
  'inv.importHistory.search': 'Rechercher par numéro de facture ou client',
  'inv.importHistory.empty': 'Aucun détail de facture importé pour cette année',
  'inv.importHistory.emptySub': 'Les chiffres comptables importés restent utilisés dans les rapports et conseils lorsqu\'ils existent.',
  'inv.importHistory.detailTitle': 'Détails du fichier d\'import',
  'inv.importHistory.dueDate': 'Date d\'échéance',
  'inv.importHistory.paidDate': 'Date de règlement',
  'inv.importHistory.remaining': 'Restant dû',
  'inv.importHistory.lines': 'Lignes importées',
  'inv.importHistory.noLines': 'Le système source n\'a fourni que les totaux de facture pour ce document.',
  'inv.importHistory.markSettled': 'Marquer comme réglée',
  'inv.importHistory.reopenStatus': 'Rouvrir le statut',
  'inv.importHistory.manualSettledNote': 'Marquée comme réglée dans Plumme sans comptabilisation.',
  'inv.importHistory.settledToast': 'La facture importée est marquée comme réglée.',
  'inv.importHistory.reopenedToast': 'La facture importée a été rouverte.',
  'inv.importHistory.statusError': 'Impossible de mettre à jour la facture importée.',
  'inv.importHistory.sourceNote': 'Importé depuis l\'ancien système – le document se trouve dans le fichier d\'import.',
  'inv.importHistory.creditReference': 'Avoir importé depuis l\'ancien système – crédite la facture {number}.',
  'inv.importHistory.creditedReference': 'Importé depuis l\'ancien système · crédité par l\'avoir {number}',
  'inv.importHistory.reanalysisTitle': 'L\'historique des factures importé doit être réanalysé',
  'inv.importHistory.reanalysisBody': 'L\'analyse enregistrée date d\'avant la lecture des avoirs depuis leurs propres feuilles. Les données sources ne sont pas modifiées.',
  'inv.importHistory.reanalysisAction': 'Lancer la réanalyse',
  'inv.importHistory.rowSource': 'Importé depuis l\'ancien système',
  'adv.sales.importedHistoryNote': 'L\'analyse combine les factures Plumme comptabilisées avec l\'historique des ventes en lecture seule issu de l\'import. Les avoirs sont déduits. {coverage}',
  'adv.sales.importedTotalsCoverage': 'L\'import contient les totaux de facture, mais pas les lignes produits pour tous les documents.',
  'adv.sales.importedLinesCoverage': 'L\'import contient également des lignes de facture pour une partie de l\'historique.',
  'inv.tab.drafts': 'Brouillons',
  'inv.filterDocType': 'Type de document',
  'inv.filterArchive': 'Archive',
  'inv.filterSeeArchived': 'Voir les archivés',
  'inv.status.draft': 'Brouillon',
  'inv.status.created': 'Non envoyé',
  'inv.status.sent': 'Envoyé',
  'inv.status.accepted': 'Accepté',
  'inv.status.confirmed': 'Confirmé',
  'inv.status.paid': 'Payé',
  'inv.status.unpaid': 'Non payé',
  'inv.status.overdue': 'En retard',
  'inv.status.credited': 'Crédité',
  'inv.kpi.invoiceCount': 'Factures',
  'inv.kpi.invoiceCount.help': 'Nombre de factures que vous avez créées sur l\'année sélectionnée, quel que soit leur statut.',
  'inv.kpi.revenue': 'Chiffre d\'affaires',
  'inv.kpi.revenue.help': 'Total de toutes les factures hors TVA de l\'année.',
  'inv.kpi.notSent': 'Non envoyé',
  'inv.kpi.notSent.help': 'Factures en brouillon en attente d\'envoi.',
  'inv.kpi.credited': 'Crédité',
  'inv.kpi.credited.help': 'Nombre d\'avoirs.',
  'inv.kpi.quotes': 'Devis',
  'inv.kpi.quotes.help': 'Nombre de devis de l\'année.',
  'inv.kpi.accepted': 'Acceptés',
  'inv.kpi.accepted.help': 'Nombre de devis acceptés par le client.',
  'inv.kpi.orders': 'Confirmations de commande',
  'inv.kpi.orders.help': 'Nombre de confirmations de commande de l\'année.',
  'inv.kpi.creditNotes': 'Avoirs',
  'inv.kpi.creditNotes.help': 'Nombre d\'avoirs de l\'année.',
  'inv.kpi.value': 'Valeur',
  'inv.kpi.value.help': 'Valeur totale hors TVA des documents de cet onglet.',
  'inv.kpi.amount': 'Montant',
  'inv.kpi.amount.help': 'Montant total hors TVA des avoirs.',
  'inv.kpi.sent': 'Envoyés',
  'inv.kpi.sent.help': 'Nombre de documents envoyés au client.',
  'inv.kpi.confirmed': 'Confirmées',
  'inv.kpi.confirmed.help': 'Confirmations de commande confirmées par le client.',
  'inv.kpi.drafts': 'Brouillons',
  'inv.kpi.drafts.help': 'Documents pas encore envoyés.',
  'inv.kpi.potentialRevenue': 'Chiffre d\'affaires potentiel',
  'inv.kpi.potentialRevenue.help': 'Valeur totale des brouillons qui peuvent encore être envoyés.',
  'inv.kpi.customers': 'Clients',
  'inv.kpi.customers.help': 'Nombre de clients uniques dans les brouillons.',
  'inv.kpi.history': 'Ancienneté',
  'inv.kpi.history.help': 'Depuis combien de temps le plus ancien brouillon attend.',
  'inv.kpi.sub.totalYear': 'Total cette année',
  'inv.kpi.sub.exVat': 'HT',
  'inv.kpi.sub.waiting': 'En attente de votre action',
  'inv.kpi.sub.creditNotes': 'Avoirs',
  'inv.kpi.sub.started': 'Documents commencés',
  'inv.kpi.sub.uniqueCustomers': 'Clients uniques',
  'inv.kpi.sub.oldestDraft': 'Plus ancien brouillon',
  'inv.kpi.sub.noDrafts': 'Aucun brouillon',
  'inv.kpi.sub.none': 'Aucun',
  'inv.kpi.sub.days': '{n} jours',
  'inv.kpi.sub.sentQuotes': 'Devis envoyés',
  'inv.kpi.sub.accepted': 'Acceptés',
  'inv.kpi.sub.confirmed': 'Confirmées',
  'inv.kpi.sub.notSent': 'Non envoyés',
  'inv.kpi.sub.sent': 'Envoyés',
  'inv.col.document': 'Document',
  'inv.col.invoice': 'Facture',
  'inv.col.date': 'Date',
  'inv.col.net': 'HT',
  'inv.col.amount': 'Montant',
  'inv.col.status': 'Statut',
  'inv.col.number': 'N°',
  'inv.col.customer': 'Client',
  'inv.netInline': 'HT {amount}',
  'inv.draftPlaceholder': 'BROUILLON',
  'inv.detail.dueTitle': 'Échéance',
  'inv.detail.dueHelp': 'La date jusqu\'à laquelle le document est valable ou doit être payé.',
  'inv.detail.statusHelp': 'Les paiements proviennent des enregistrements PaymentEntry comptabilisés. Les devis et confirmations de commande affichent le statut de réalisation.',
});
